// import React from "react";
// import ReactDOM from "react-dom";
// // import dotEnv from "dotenv";
// import reportWebVitals from "./reportWebVitals";
// import App from "./app/App";
// import "./assets/styles/styles.scss";

// // dotEnv.config();

// ReactDOM.render(<App />, document.getElementById("root"));
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./app/App";
import reportWebVitals from './reportWebVitals';
import "./assets/styles/styles.scss";
import { Toaster } from './components/ui/toaster';
import { BrowserRouter as Router } from "react-router-dom";
import { TourProvider } from './components/ui/TourContext';
import TourBubble from './components/ui/TourBubble';
const root = ReactDOM.createRoot(document.getElementById('root'));
const prefersDark = localStorage.getItem("darkMode") === "true";
if (prefersDark) {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}
root.render(
   <Router> 
  <React.StrictMode>
    <TourProvider>
    <Toaster />
    <TourBubble />
      <App />
    </TourProvider>
  </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
